import { Stack } from '@mui/material'
import { type FC } from 'react'
import { CandidateSearchResultsTable } from '../../components/CandidateSearchResultsTable'
import { type CandidateTableColumnDefinition } from '../../components/candidateTableColumns'
import { useCandidateFilterTabs } from '../../components/CandidateTableToolbar/useCandidateFilterTabs'
import { buildCandidateResearchFilterTabs } from '../../components/CandidateTableToolbar/candidateFilterTabs'
import { useCandidateSqlSearch } from 'recruiter/hooks'

interface CandidateSearchSqlProps {
    columns: CandidateTableColumnDefinition[]
    topActionButtons?: React.ReactNode
    afterSearchContent?: React.ReactNode
    endContent?: React.ReactNode
    footerStartContent?: React.ReactNode
    pinnedColumns?: { left?: string[]; right?: string[] }
}

export const CandidateSearchSql: FC<CandidateSearchSqlProps> = ({
    columns,
    topActionButtons,
    afterSearchContent,
    endContent,
    footerStartContent,
    pinnedColumns,
}) => {
    const {
        tableState,
        setTableState,
        data,
        isLoading,
        selectedCandidateIds,
        setSelectedCandidateIds,
    } = useCandidateSqlSearch()

    const tabs = useCandidateFilterTabs(buildCandidateResearchFilterTabs)

    return (
        <Stack direction="row" height="100%">
            <CandidateSearchResultsTable
                columns={columns}
                containerProps={{ elevation: 1 }}
                data={data}
                loading={isLoading}
                sort={tableState.sort}
                selectedCandidateIds={selectedCandidateIds}
                onSortChange={(sort) => setTableState({ sort })}
                onSelectionChange={setSelectedCandidateIds}
                filterTabs={tabs}
                actionButtons={topActionButtons}
                afterSearchContent={afterSearchContent}
                endContent={endContent}
                footerStartContent={footerStartContent}
                pinnedColumns={pinnedColumns}
            />
        </Stack>
    )
}
